import React from 'react';
import Pending from './pending';
import request from '../../request';
import { Link } from 'react-router-dom';
import Heading from './components/heading';
import StudiesContainer from '../shared/studies';
export default class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      studies: JSON.parse(localStorage.getItem('studies')),
    };
  }

  async componentDidMount() {
    try {
      this.setState({ loading: true });
      let studies = await request({ url: 'studies' });
      localStorage.setItem('studies', JSON.stringify(studies));
      this.setState({ studies, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  render() {
    let { studies, loading } = this.state;
    return (
      <div id="dashboard">
        <Heading
          title="Hello!"
          button={
            process.env.REACT_APP_DISABLE_UPLOAD ? null : (
              <Link className="action" to="/add/">
                Add Study
              </Link>
            )
          }
        />
        <Pending studies={studies} loading={loading} />
        <div className="dots" />
        <h5 className="heading open">In Progress</h5>
        {studies && studies.progress && studies.progress.length === 10 ? (
          <p className="all">
            <Link to="/types/progress">View All</Link>
          </p>
        ) : null}
        <StudiesContainer
          studies={studies ? studies.progress : null}
          empty="There are no studies in progress"
          loading={loading}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/dashboard.js